angular.module('sample.widgets.recentlyAddedAssets', ['adf.provider'])
    .config(['dashboardProvider', function (dashboardProvider) {
        dashboardProvider
            .widget('recently-added-assets', {
                id: 'recently-added-assets',
                title: 'Recently Added Assets',
                description: 'Recently added assets',
                controller: 'RecentlyAddedAssetsWidgetController',
                template: '<div id="recentlyAddedAssetsWidget"><eic-recently-added-assets-container></eic-recently-added-assets-container></div>'
            });
    }])
    .controller('RecentlyAddedAssetsWidgetController', ['$scope', function ($scope) {
        $scope.componentName = 'RecentlyAddedAssetsWidgetController';
    }]);
